import React, { createContext, MutableRefObject, PropsWithChildren, useContext } from 'react';
import { DealBuilderContactsData, DealBuilderEquipmentSource, DealBuilderVOSource } from '../types';
import { DealBuilderEntity, InventoryEquipmentItem, StartDealBuilderContactInput } from '../api';
import { Nullable } from 'global';
import { EquipmentDelivery } from 'modules/equipment/types';

export type DeliverySubmitRef = MutableRefObject<
  Nullable<{ submit: () => Promise<{ isValid: boolean; formValues: EquipmentDelivery }> }>
>;

export interface DealBuilderContextValue {
  vo: Nullable<DealBuilderVOSource>;
  contactsData: DealBuilderContactsData;
  contactsLoading: boolean;
  equipmentData: Nullable<DealBuilderEquipmentSource[]>;
  selectedEquipmentItem: Nullable<InventoryEquipmentItem>;
  setSelectedEquipmentItem: (item: Nullable<InventoryEquipmentItem>) => void;
  deliverySubmitRef: DeliverySubmitRef;
  activeEntity: Nullable<DealBuilderEntity>;
  historyEntities: DealBuilderEntity[];
  setActiveEntity: (proposalId: string) => void;
  ensureDealBuilder: (contacts: StartDealBuilderContactInput[]) => Promise<Nullable<string>>;
  startNewQuote: () => Promise<Nullable<string>>;
  upsertContacts: (ownerPgIds: string[], accountContactIds: string[]) => void;
  upsertEquipments: (equipmentIds: string[], overrideProposalId?: string) => void;
}

const DealBuilderContext = createContext<DealBuilderContextValue | null>(null);

export const DealBuilderContextProvider = ({
  value,
  children,
}: PropsWithChildren<{ value: DealBuilderContextValue }>) => (
  <DealBuilderContext.Provider value={value}>{children}</DealBuilderContext.Provider>
);

export const useDealBuilderContext = (): DealBuilderContextValue => {
  const context = useContext(DealBuilderContext);
  if (!context) throw new Error('useDealBuilderContext must be used within a DealBuilderContextProvider');
  return context;
};
